import {
  grey300, grey500, grey700, orange500, blue600, red800, red500, orange800,
} from 'material-ui/styles/colors';
import base from '../../styles';

const controlsIcon = {
  fill: grey700,
  cursor: 'pointer',
  backgroundColor: 'white',
  borderRadius: 2,
  boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)',
  display: 'block',
  marginBottom: 10,
};

export const styles = {
  root: {
    position: 'relative',
  },
  map: {
    backgroundColor: grey300,
    width: '100%',
    marginTop: 15,
    position: 'relative',
    height: 325,
    '@media (min-width: 800px)': {
      height: 400,
    },
    '@media (min-width: 1200px)': {
      height: 450,
    },
    '@media (min-width: 1400px)': {
      height: 500,
    },
  },
  mapFull: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
  },
  input: {
    padding: 10,
    border: 'none',
    width: 225,
    outline: 'none',
    marginTop: 10,
  },
  searchIcon: {
    fill: grey500,
  },
  controlsFull: {
    position: 'fixed',
  },
  fullscreenIcon: {
    ...controlsIcon,
    width: 28,
    height: 28,
    padding: 2,
  },
  myLocationIcon: {
    ...controlsIcon,
    width: 28,
    height: 28,
    padding: 4,
  },
  legend: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginTop: 10,
  },
  legendItem: {
    marginTop: 3,
  },
  legendIcon: {
    verticalAlign: 'top',
    display: 'inline-block',
  },
  legendLabel: {
    marginLeft: 10,
    fontSize: 12,
    color: base.textColor,
    display: 'inline-block',
    verticalAlign: 'top',
    lineHeight: '24px',
  },
  search: {
    marginTop: '10px',
    marginLeft: '10px',
    padding: '10px',
    border: 'none',
    width: '240px',
    outline: 'none',
    fontSize: '14px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2),0 -1px 0px rgba(0,0,0,0.02)',
  },
};

export const icons = {
  fault: {
    path: 'M 12, 12 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0',
    fillColor: red500,
    fillOpacity: 1,
    anchor: new window.google.maps.Point(0, 0),
    strokeWeight: 2,
    strokeColor: red800,
    scale: 0.85,
  },
  maintenance: {
    path: 'M 12, 12 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0',
    fillColor: orange500,
    fillOpacity: 1,
    anchor: new window.google.maps.Point(0, 0),
    strokeWeight: 2,
    strokeColor: orange800,
    scale: 0.85,
  },
  location: {
    path: 'M 12, 12 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0',
    fillColor: blue600,
    fillOpacity: 1,
    anchor: new window.google.maps.Point(0, 0),
    strokeWeight: 2,
    strokeColor: 'white',
    scale: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Map/styles.js